import { useContext, useEffect, useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { 
  Button, 
  Container, 
  Table,
  Modal, 
  Row,
  Col,
  Form
} from 'react-bootstrap';
import { AiFillPlusSquare } from 'react-icons/ai';
import { FaSistrix } from 'react-icons/fa'
import { IoBarChartSharp } from 'react-icons/io5'
import { FaFileExcel } from 'react-icons/fa';
import exportFromJSON from 'export-from-json';

import styles from './Chamados.module.css';
import { UserContext } from '../../context/UserContext';
import { includeLeftZero } from '../../helpers/includeLeftZero';
import getAllChamados from '../../api/getAllChamados';
import getChamadosByUser from '../../api/getChamadosByUser';
import getChamadosByResponder from '../../api/getChamadosByResponder';
import { formatDate } from '../../helpers/formatDate';
import { formatDateTime } from '../../helpers/formatDateTime';
import { decrypt } from '../../helpers/cryptography';
import { digitsMask } from '../../helpers/masks';
import { PaginationMenu } from '../../components/PaginationMenu';
import getCategorias from '../../api/getCategorias';
import getUnidades from '../../api/getUnidades';
import getChamadosBusca from '../../api/getChamadosBusca';
import Loading from '../../components/Loading';
import tiEmpresasResp from '../../helpers/tiEmpresasResp';
import getCodigosChamados from '../../api/getCodigosChamados';

const Chamados = () => {
  const location = useLocation();
  const { isAdmin, isConsulta, isUser, isResp } = useContext(UserContext);
  const history = useHistory();
  const firstSearchByEffect = useRef(true);
  const firstSearchBy2Effect = useRef(true);
  const [currentPage, setCurrentPage] = useState(() => {
    const queryParams = new URLSearchParams(location.search);
    const pagina = queryParams.get('pagina');

    if (pagina) {
      return pagina;
    }

    return 1;
  });
  const [searchBy, setSearchBy] = useState(() => {
    const queryParams = new URLSearchParams(location.search);
    const busca = queryParams.get('busca');

    if (busca) {
      return busca;
    }

    return '';
  });
  const [search, setSearch] = useState(() => {
    const queryParams = new URLSearchParams(location.search);
    const valor = queryParams.get('valor');

    if (valor) {
      return decodeURIComponent(valor);
    }

    return '';
  });
  const [searchBy2, setSearchBy2] = useState(() => {
    const queryParams = new URLSearchParams(location.search);
    const busca2 = queryParams.get('busca2');

    if (busca2) {
      return busca2;
    }

    return '';
  });
  const [search2, setSearch2] = useState(() => {
    const queryParams = new URLSearchParams(location.search);
    const valor2 = queryParams.get('valor2');

    if (valor2) {
      return decodeURIComponent(valor2);
    }

    return '';
  });
  const [filterBy, setFilterBy] = useState('numeroChamado');
  const [totalPages, setTotalPages] = useState(null);
  const [chamados, setChamados] = useState(null);
  const [sortCodigo, setSortCodigo] = useState(false);
  const [orderBy, setOrderBy] = useState('desc');
  const [excelLoading, setExcelLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModalBusca, setShowModalBusca] = useState(false);
  const [codigos, setCodigos] = useState([]);
  const [searchLabel, setSearchLabel] = useState('Selecione o Tipo:');
  const [searchLabel2, setSearchLabel2] = useState('Selecione o Tipo:');
  const [categorias, setCategorias] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [unidades, setUnidades] = useState([]);

  useEffect(() => {
    const handlePopState = async () => {
      setLoading(true);

      const queryParams = new URLSearchParams(window.location.search);
      const pagina = queryParams.get('pagina') || '1';
      const busca = queryParams.get('busca') || '';
      const valor = queryParams.get('valor') || '';
      const busca2 = queryParams.get('busca2') || '';
      const valor2 = queryParams.get('valor2') || '';

      setCurrentPage(Number(pagina));
      setSearchBy(busca);
      setSearch(valor ? decodeURIComponent(valor) : '');
      setSearchBy2(busca2);
      setSearch2(valor2 ? decodeURIComponent(valor2) : '');

      const cacheKey = `chamados_${busca}_${valor}_${busca2}_${valor2}_${pagina}`;
      const cached = sessionStorage.getItem(cacheKey);

      if (cached) {
        const { resultado } = JSON.parse(cached);

        setChamados(resultado.chamados);
        setLoading(false);

        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
        
        return;
      }

      if (busca && valor) {
        await getChamadosFiltered(Number(pagina), {
          searchByValue: busca,
          searchValue: decodeURIComponent(valor),
          searchBy2Value: busca2,
          search2Value: valor2 ? decodeURIComponent(valor2) : ''
        });
      } else {
        await getChamados();
      }

      setLoading(false);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    sessionStorage.clear();
  }, [location.pathname]);

  const getChamados = async () => {
    setLoading(true);

    const login = JSON.parse(localStorage.getItem('login'));
    const email = decrypt(login?.user?.email);

    if (isAdmin) {
      const response = await getAllChamados(currentPage ? currentPage : 1, 50, filterBy, orderBy);

      setChamados(response?.chamados);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);

      sessionStorage.setItem('chamados_cache', JSON.stringify({
        filtros: { busca: '', valor: '', pagina: String(currentPage) },
        resultado: response,
        timestamp: Date.now()
      }));

      setLoading(false);

      return;
    } else if (isResp) {
      const response = await getChamadosByResponder(email, currentPage, 50, filterBy, orderBy);

      setChamados(response?.chamados);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);

      sessionStorage.setItem('chamados_cache', JSON.stringify({
        filtros: { busca: '', valor: '', pagina: String(currentPage) },
        resultado: response,
        timestamp: Date.now()
      }));

      setLoading(false);

      return;
    } else if (isUser) {
      const response = await getChamadosByUser(email, currentPage, 50, filterBy, orderBy);

      setChamados(response?.chamados);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);

      sessionStorage.setItem('chamados_cache', JSON.stringify({
        filtros: { busca: '', valor: '', pagina: String(currentPage) },
        resultado: response,
        timestamp: Date.now()
      }));

      setLoading(false);

      return;
    } else {
      const response = await getChamadosByUser(email, currentPage, 50, filterBy, orderBy);

      setChamados(response?.chamados);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);

      sessionStorage.setItem('chamados_cache', JSON.stringify({
        filtros: { busca: '', valor: '', pagina: String(currentPage) },
        resultado: response,
        timestamp: Date.now()
      }));

      setLoading(false);

      return;
    }
  };

  useEffect(() => {
    const getAllCategorias = async () => {
      const response = await getCategorias();
      const categorias = await response?.map(item => item.categoria);
      const subcategoriasArray = await response?.map(item => item.subcategoria.map(item => item.nome));
      const subcategorias = subcategoriasArray.flat();

      setCategorias(categorias);
      setSubcategorias(subcategorias);
    };

    getAllCategorias();
  }, []);

  useEffect(() => {
    const getAllUnidades = async () => {
      const response = await getUnidades('sisged');
      const unidades = await response.map(item => item.unidade);

      setUnidades(unidades);
    };

    getAllUnidades();
  }, []);

  useEffect(() => {
    if (searchBy === 'código') {
      setSearchLabel('Digite o código:');
    } else if (searchBy === 'nome') {
      setSearchLabel('Digite o nome:');
    }

    if (firstSearchByEffect.current) {
      firstSearchByEffect.current = false;

      return;
    }

    setSearch('');
    setSearchBy2('');
    setSearch2('');
  }, [searchBy]);

  useEffect(() => {
    if (searchBy2 === 'código') {
      setSearchLabel2('Digite o código:');
    } else if (searchBy2 === 'nome') {
      setSearchLabel2('Digite o nome:');
    }

    if (firstSearchBy2Effect.current) {
      firstSearchBy2Effect.current = false;

      return;
    }

    setSearch2('');
  }, [searchBy2]);

  const getChamadosFiltered = async (
    page = currentPage,
    {
      searchByValue = searchBy,
      searchValue = search,
      searchBy2Value = searchBy2,
      search2Value = search2
    } = {}
  ) => {
    setLoading(true);
    
    const login = JSON.parse(localStorage.getItem('login'));
    const email = decrypt(login?.user?.email);
    let role;

    if (isAdmin) {
      role = 'ADMIN';
    } else if (isResp) {
      role = 'RESP';
    } else {
      role = 'USER';
    }

    if (searchByValue && searchValue) {
      const response = await getChamadosBusca(searchByValue, searchValue, role, page, 50, email, searchBy2Value, search2Value);
      
      setChamados(response?.chamados);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);

      const cacheKey = `chamados_${searchByValue}_${searchValue}_${searchBy2Value}_${search2Value}_${page}`;

      sessionStorage.setItem(cacheKey, JSON.stringify({
        filtros: { busca: searchByValue, valor: searchValue, busca2: searchBy2Value, valor2: search2Value, pagina: String(page) },
        resultado: response,
        timestamp: Date.now()
      }));

      setLoading(false);
    }
  };

  const handleSearchBy = e => {
    setSearchBy(e.target.value);
  };

  const handleSearch = e => {
    if (searchBy === 'código') {
      e.target.value = digitsMask(e.target.value);

      setSearch(e.target.value);
    } else {
      setSearch(e.target.value);
    }
  };

  const handleSearch2 = e => {
    if (searchBy2 === 'código') {
      e.target.value = digitsMask(e.target.value);

      setSearch2(e.target.value);
    } else {
      setSearch2(e.target.value);
    }
  };

  const handleSearchBy2 = e => {
    setSearchBy2(e.target.value);
  };

  useEffect(() => {
    setLoading(true);

    const getChamadosTodos = async () => {
      const login = JSON.parse(localStorage.getItem('login'));
      const email = decrypt(login?.user?.email);

      if (isAdmin) {
        const response = await getCodigosChamados(email, 'ADMIN');

        setCodigos(response);
        setLoading(false);

        return;
      } else if (isResp) {
        const response = await getCodigosChamados(email, 'RESP');

        setCodigos(response);
        setLoading(false);

        return;
      } else {
        const response = await getCodigosChamados(email, '');

        setCodigos(response);
        setLoading(false);

        return;
      }
    };

    getChamadosTodos();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModalBuscaClose = () => {
    setShowModalBusca(false);
  };

  const toNewTicket = () => {
    history.push('/solicitacoes/novo');
  };

  const toExcel = async () => {
    setExcelLoading(true);

    const login = JSON.parse(localStorage.getItem('login'));
    const email = decrypt(login?.user?.email);

    const fileName = 'solicitacoes';
    const exportType = 'xls';

    let getAll;

    if (isAdmin) {
      getAll = await getAllChamados(1, 100000);
    } else if (isResp) {
      getAll = await getChamadosByResponder(email, 1, 100000);
    } else {
      getAll = await getChamadosByUser(email, 1, 100000);
    }

    const allData = getAll.chamados;
    
    const data = allData.map(item => { 
      const excelData = {
        id: item._id,
        numero_chamado: item.numeroChamado,
        email: decrypt(item.email),
        nome: decrypt(item.nome),
        telefone: item.telefone ? decrypt(item.telefone) : '',
        unidade: item.unidade,
        categoria: item.categoria,
        subcategoria: item.subcategoria,
        login_sistemas: item.loginSistemas ? item.loginSistemas.sistema : '',
        relato: item.relato ? item.relato : '',
        sla: item.sla,
        status: item.status,
        usuario_responsavel_pela_resposta: item.userResp ?? '',
        equipamentoEngenhariaClinica: item.equipamentoEngenhariaClinica,
        responder: decrypt(item.responder),
        observacao: item.obs ? item.obs : '',
        veiculo_data: !item.solicitacaoVeiculo?.veiculoData ? '' : formatDate(item.solicitacaoVeiculo?.veiculoData),
        veiculo_hora: item.solicitacaoVeiculo?.veiculoHora,
        veiculo_tempo: item.solicitacaoVeiculo?.veiculoTempo,
        veiculo_passageiro: item.solicitacaoVeiculo?.veiculoPassageiro,
        veiculo_telefone: item.solicitacaoVeiculo?.veiculoTelefone,
        veiculo_motivo: item.solicitacaoVeiculo?.veiculoMotivo,
        veiculo_saida: item.solicitacaoVeiculo?.veiculoSaida,
        veiculo_destino: item.solicitacaoVeiculo?.veiculoDestino,
        data_inicio: !item.createdAt ? '' : formatDate(item.createdAt),
        data_final: !item.finalAt ? '' : formatDate(item.finalAt),
        pontoEletronico: item.pontoEletronico?.assunto,
      };

      if (item.materiaisEscritorio.length > 0) {
        Array.from({ length: item.materiaisEscritorio.length }).forEach((_, i) => {
          excelData[`materiais_escritorio_nome_${i + 1}`] = item.materiaisEscritorio[i].material;
          excelData[`materiais_escritorio_qtd_${i + 1}`] = item.materiaisEscritorio[i].quantidade;
        });
      }

      if (item.materiaisLimpeza.length > 0) {
        Array.from({ length: item.materiaisLimpeza.length }).forEach((_, i) => {
          excelData[`materiais_limpeza_nome_${i + 1}`] = item.materiaisLimpeza[i].material;
          excelData[`materiais_limpeza_qtd_${i + 1}`] = item.materiaisLimpeza[i].quantidade;
        });
      }

      if (item.materiaisExpediente.length > 0) {
        Array.from({ length: item.materiaisExpediente.length }).forEach((_, i) => {
          excelData[`materiais_expediente_nome_${i + 1}`] = item.materiaisExpediente[i].material;
          excelData[`materiais_expediente_qtd_${i + 1}`] = item.materiaisExpediente[i].quantidade;
        });
      }

      if (item.requerimentoInsumos.length > 0) {
        Array.from({ length: item.requerimentoInsumos.length }).forEach((_, i) => {
          excelData[`requerimento_insumos_tipo_de_insumo_${i + 1}`] = item.requerimentoInsumos[i].tipoInsumo;
          excelData[`requerimento_insumos_cod_interno_${i + 1}`] = item.requerimentoInsumos[i].codigoInterno ?? '-';
          excelData[`requerimento_insumos_descricao_${i + 1}`] = item.requerimentoInsumos[i].descricao;
          excelData[`requerimento_insumos_qtd_${i + 1}`] = item.requerimentoInsumos[i].quantidade;
          excelData[`requerimento_insumos_qtd_atendida_${i + 1}`] = item.requerimentoInsumos[i].quantidadeAtendida;
        });
      }

      if (item.requerimentoMedicamentos.length > 0) {
        Array.from({ length: item.requerimentoMedicamentos.length }).forEach((_, i) => {
          excelData[`requerimento_medicamentos_tipo_de_insumo_${i + 1}`] = item.requerimentoMedicamentos[i].tipoMedicamento;
          excelData[`requerimento_medicamentos_cod_interno_${i + 1}`] = item.requerimentoMedicamentos[i].codigoInterno ?? '-';
          excelData[`requerimento_medicamentos_descricao_${i + 1}`] = item.requerimentoMedicamentos[i].descricao;
          excelData[`requerimento_medicamentos_qtd_${i + 1}`] = item.requerimentoMedicamentos[i].quantidade;
          excelData[`requerimento_medicamentos_qtd_atendida_${i + 1}`] = item.requerimentoMedicamentos[i].quantidadeAtendida;
        });
      }

      if (item.briefing) {
        excelData['briefingPorque'] = item.briefing.briefingPorque;
        excelData['briefingMedidas'] = item.briefing.briefingMedidas;
        excelData['briefingOnde'] = item.briefing.briefingOnde;
        excelData['briefingPrazo'] = formatDate(item.briefing.briefingPrazo);
        excelData['briefingDetalhe'] = item.briefing.briefingDetalhe;

        if (item.briefing.briefingArquivos.length > 0) {
          Array.from({ length: item.briefing.briefingArquivos.length }).forEach((_, i) => {
            excelData[`briefing_arquivo_originalName_${i + 1}`] = item.briefing.briefingArquivos[i].originalName;
            excelData[`briefing_arquivo_fileName_${i + 1}`] = item.briefing.briefingArquivos[i].fileName;
          });
        }
      }

      if (item.erp) {
        excelData['erpNome'] = decrypt(item.erp.erpNome);
        excelData['erpEmail'] = decrypt(item.erp.erpEmail);
        excelData['erpMatricula'] = item.erp.erpMatricula;
        excelData['erpUnidade'] = item.erp.erpUnidade;
        excelData['erpAdministrador'] = item.erp.erpAdministrador;
        excelData['erpCadastrosComuns'] = item.erp.erpCadastrosComuns;
        excelData['erpCadastrosComumFinanceiro'] = item.erp.erpCadastrosComumFinanceiro;
        excelData['erpGestaoDeProcessos'] = item.erp.erpGestaoDeProcessos;
        excelData['erpCompras'] = item.erp.erpCompras;
        excelData['erpContratoCompras'] = item.erp.erpContratoCompras;
        excelData['erpContasPagar'] = item.erp.erpContasPagar;
        excelData['erpPagamentoEscritural'] = item.erp.erpPagamentoEscritural;
        excelData['erpContasReceber'] = item.erp.erpContasReceber;
        excelData['erpTesouraria'] = item.erp.erpTesouraria;
        excelData['erpIntegracaoPadrao'] = item.erp.erpIntegracaoPadrao;
        excelData['erpContabil'] = item.erp.erpContabil;
        excelData['erpPatrimonio'] = item.erp.erpPatrimonio;
        excelData['erpOrcamento'] = item.erp.erpOrcamento;
        excelData['erpReinf'] = item.erp.erpReinf;
        excelData['erpEfd'] = item.erp.erpEfd;
        excelData['erpEcd'] = item.erp.erpEcd;
        excelData['erpEcf'] = item.erp.erpEcf;
      }

      if (item.suporteTi) {
        excelData['ti_telefone_contato'] = item.suporteTi.telContatoTi ? decrypt(item.suporteTi.telContatoTi) : '';
        excelData['ti_patrimonio'] = item.suporteTi.patrimonioTi;
        excelData['empresa_responsavel'] = item.suporteTi.empresaResp;
      }

      return excelData;
    });

    exportFromJSON({ data, fileName, exportType });

    setExcelLoading(false);
  };

  const handleSortCodigo = () => {
    setSortCodigo(!sortCodigo);

    if (!sortCodigo) {
      setFilterBy('numeroChamado');
      setOrderBy('asc');
    } else {
      setFilterBy('numeroChamado');
      setOrderBy('desc');
    }
  };

  const toGraficos = () => {
    history.push('/solicitacoes/graficos');
  };

  const searchOptions = [
    'Todos',
    'código',
    'categoria',
    'subcategoria',
    'nome',
    'unidade',
    'status',
    'data'
  ];

  const login = JSON.parse(localStorage.getItem('login'));
  const email = decrypt(login?.user?.email);

  if (isAdmin || email === 'informatica@fesaude.niteroi.rj.gov.br' || email === 'titenq@gmail.com') {
    searchOptions.push('Empresa Responsável');
  }

  const statusOptions = [
    'Aberto',
    'Em Andamento',
    'Cancelado',
    'Finalizado'
  ];

  useEffect(() => {
    const cacheKey = `chamados_${searchBy}_${search}_${searchBy2}_${search2}_${currentPage}`;
    const cached = sessionStorage.getItem(cacheKey);

    if (cached) {
      const { resultado } = JSON.parse(cached);
      setChamados(resultado.chamados);
      setLoading(false);
      
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);

      return;
    }

    const fetch = async () => {
      setLoading(true);

      if (searchBy && search) {
        await getChamadosFiltered();
      } else {
        await getChamados();
      }

      setLoading(false);
      window.scrollTo(0, 0);
    };

    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, isAdmin, isResp, isUser, filterBy, orderBy]);

  const handleClearSearch = () => {
    setSearch('');
    setSearchBy('');
    setSearch2('');
    setSearchBy2('');
    setCurrentPage(1);
  };

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    if (searchBy === 'Todos') {
      setSearch('');
      setSearchBy('');
      setSearch2('');
      setSearchBy2('');
      setCurrentPage(1);
      setLoading(false);

      history.push('/solicitacoes?pagina=1');

      return;
    }

    if (searchBy === 'código') {
      if (codigos.includes(Number(search))) {
        history.push(`/solicitacao/${search}`);

        return;
      }

      setShowModalBusca(true);
      setLoading(false);

      return;
    }

    setLoading(true);

    setCurrentPage(1);

    const queryParams = new URLSearchParams({
      pagina: 1,
      busca: searchBy,
      valor: search,
      limit: 50
    });

    if (searchBy2 && search2) {
      queryParams.append('busca2', searchBy2);
      queryParams.append('valor2', search2);
    }

    history.push(`/solicitacoes?${queryParams.toString()}`);

    getChamadosFiltered(1);
  };

  return (
    <Container className='pb-4'>
      <div className={styles.title}>
        <h1 className="h2 text-center my-3">Solicitações</h1>
        <div className={styles.buttons}>
          {(isUser || isConsulta) && (
            <Button onClick={toNewTicket} variant="flat" className={styles.btn}>
              <AiFillPlusSquare className={styles.icon} />
              <span className={styles.textToHide}>Nova Solicitação</span>
            </Button>
          )}
          
          {!excelLoading && (
            <Button onClick={toExcel} className="mt-3" variant="success">
              <FaFileExcel className={styles.icon} />
              <span className={styles.textToHide}>Excel</span>
            </Button>
          )}

          {excelLoading && (
            <Button onClick={toExcel} className="mt-3" variant="success" disabled>
              <FaFileExcel className={styles.icon} />
              <span className={styles.textToHide}>Baixando...</span>
            </Button>
          )}

          {(isAdmin || isResp) && (
            <Button onClick={toGraficos} className="mt-3" variant="warning">
              <IoBarChartSharp className={styles.icon} />
              <span className={styles.textToHide}>Gráficos</span>
            </Button>
          )}
        </div>
      </div>

      {loading && <Loading />}

      {!loading && (
        <Form
        onSubmit={handleSubmit}
        noValidate
      >
        <Row>
          <Col sm={2}>
            <Form.Group controlId="searchBy" className={styles.searchType}>
              <Form.Label>Buscar por:</Form.Label>
              <Form.Select
                className="border border-secondary"
                required
                name="searchBy"
                onChange={e => handleSearchBy(e)}
                value={searchBy}
              >
                <option value="" disabled>Selecione o tipo:</option>
                {searchOptions && searchOptions.map(item => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {(searchBy === 'código' || searchBy === 'nome') && (
            <Col sm={4}>
              <Form.Group controlId="search" className={styles.searchField}>
                <Form.Label>{searchLabel}</Form.Label>
                <Form.Control
                  type="text"
                  required
                  name="search"
                  onChange={e => handleSearch(e)}
                  value={search}
                  disabled={!searchBy}
                />
              </Form.Group>
            </Col>
          )}

          {searchBy === 'categoria' && (
            <Col sm={4}>
              <Form.Group controlId="search" className={styles.searchField}>
                <Form.Label>Selecione a categoria:</Form.Label>
                <Form.Select
                  className="border border-secondary"
                  required
                  name="search"
                  onChange={e => handleSearch(e)}
                  value={search}
                  disabled={!searchBy}
                >
                  <option value="" disabled>Selecione a categoria:</option>
                  {categorias && categorias.map(item => (
                    <option key={item} value={item}>{item}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          )}

          {searchBy === 'subcategoria' && (
            <Col sm={4}>
              <Form.Group controlId="search" className={styles.searchField}>
                <Form.Label>Selecione a subcategoria:</Form.Label>
                <Form.Select
                  className="border border-secondary"
                  required
                  name="search"
                  onChange={e => handleSearch(e)}
                  value={search}
                  disabled={!searchBy}
                >
                  <option value="" disabled>Selecione a subcategoria:</option>
                  {subcategorias && subcategorias.map(item => (
                    <option key={item} value={item}>{item}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          )}

          {searchBy === 'unidade' && (
            <Col sm={4}>
              <Form.Group controlId="search" className={styles.searchField}>
                <Form.Label>Selecione a lotação:</Form.Label>
                <Form.Select
                  className="border border-secondary"
                  required
                  name="search"
                  onChange={e => handleSearch(e)}
                  value={search}
                  disabled={!searchBy}
                >
                  <option value="" disabled>Selecione a lotação:</option>
                  {unidades && unidades.map(item => (
                    <option key={item} value={item}>{item}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          )}

          {searchBy === 'status' && (
            <Col sm={4}>
              <Form.Group controlId="search" className={styles.searchField}>
                <Form.Label>Selecione o status:</Form.Label>
                <Form.Select
                  className="border border-secondary"
                  required
                  name="search"
                  onChange={e => handleSearch(e)}
                  value={search}
                  disabled={!searchBy}
                >
                  <option value="" disabled>Selecione o status:</option>
                  {statusOptions.map(item => (
                    <option key={item} value={item}>{item}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            )}
            
          {searchBy === 'Empresa Responsável' && (
            <Col sm={4}>
              <Form.Group controlId="search" className={styles.searchField}>
                <Form.Label>Selecione a Empresa Responsável:</Form.Label>
                <Form.Select
                  className="border border-secondary"
                  required
                  name="search"
                  onChange={e => handleSearch(e)}
                  value={search}
                  disabled={!searchBy}
                >
                  <option value="">Selecione a Empresa Responsável</option>
                  {tiEmpresasResp.map(item => (
                    <option key={item} value={item}>{item}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          )}

          {searchBy === 'data' && (
            <Col sm={4}>
                <Form.Group controlId="search" className={styles.searchField}>
                <Form.Label>Selecione uma data:</Form.Label>
                <Form.Control
                  type="date"
                  name="search"
                  onChange={e => handleSearch(e)}
                  value={search}
                  disabled={!searchBy}
                />
              </Form.Group>
            </Col>
          )}

          <Col sm={2} className={styles.button_col}>
            <Button variant="flat" className={styles.button_list} type="submit" disabled={!search && searchBy !== 'Todos'}>
              <FaSistrix className={styles.icon_list} /> Buscar
            </Button>
          </Col>
            
          {searchBy && search && (
            <Col sm={2} className={styles.button_col}>
              <Button
                className={styles.button_clear}
                variant="danger"
                onClick={handleClearSearch}
              >
                Limpar
              </Button>
            </Col>
          )}
        </Row>

        {search && searchBy !== 'Todos' && (
          <Row>
            <Col sm={2}>
              <Form.Group controlId="searchBy2" className={styles.searchType}>
                <Form.Label>2° Campo:</Form.Label>
                <Form.Select
                  className="border border-secondary"
                  required
                  name="searchBy2"
                  onChange={e => handleSearchBy2(e)}
                  value={searchBy2}
                >
                  <option value="" disabled>Selecione o tipo:</option>
                  {searchOptions && searchOptions.filter(item => item !== 'Todos' && item !== searchBy).map(item => (
                    <option key={item} value={item}>{item}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {(searchBy2 === 'código' || searchBy2 === 'nome') && (
              <Col sm={4}>
                <Form.Group controlId="search2" className={styles.searchField}>
                  <Form.Label>{searchLabel2}</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="search2"
                    onChange={e => handleSearch2(e)}
                    value={search2}
                    disabled={!searchBy2}
                  />
                </Form.Group>
              </Col>
            )}

            {searchBy2 === 'categoria' && (
              <Col sm={4}>
                <Form.Group controlId="search2" className={styles.searchField}>
                  <Form.Label>Selecione a categoria:</Form.Label>
                  <Form.Select
                    className="border border-secondary"
                    required
                    name="search2"
                    onChange={e => handleSearch2(e)}
                    value={search2}
                    disabled={!searchBy2}
                  >
                    <option value="" disabled>Selecione a categoria:</option>
                    {categorias && categorias.map(item => (
                      <option key={item} value={item}>{item}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {searchBy2 === 'subcategoria' && (
              <Col sm={4}>
                <Form.Group controlId="search2" className={styles.searchField}>
                  <Form.Label>Selecione a subcategoria:</Form.Label>
                  <Form.Select
                    className="border border-secondary"
                    required
                    name="search2"
                    onChange={e => handleSearch2(e)}
                    value={search2}
                    disabled={!searchBy2}
                  >
                    <option value="" disabled>Selecione a subcategoria:</option>
                    {subcategorias && subcategorias.map(item => (
                      <option key={item} value={item}>{item}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {searchBy2 === 'unidade' && (
              <Col sm={4}>
                <Form.Group controlId="search2" className={styles.searchField}>
                  <Form.Label>Selecione a lotação:</Form.Label>
                  <Form.Select
                    className="border border-secondary"
                    required
                    name="search2"
                    onChange={e => handleSearch2(e)}
                    value={search2}
                    disabled={!searchBy2}
                  >
                    <option value="" disabled>Selecione a lotação:</option>
                    {unidades && unidades.map(item => (
                      <option key={item} value={item}>{item}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {searchBy2 === 'status' && (
              <Col sm={4}>
                <Form.Group controlId="search2" className={styles.searchField}>
                  <Form.Label>Selecione o status:</Form.Label>
                  <Form.Select
                    className="border border-secondary"
                    required
                    name="search2"
                    onChange={e => handleSearch2(e)}
                    value={search2}
                    disabled={!searchBy2}
                  >
                    <option value="" disabled>Selecione o status:</option>
                    {statusOptions.map(item => (
                      <option key={item} value={item}>{item}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {searchBy2 === 'Empresa Responsável' && (
              <Col sm={4}>
                <Form.Group controlId="search2" className={styles.searchField}>
                  <Form.Label>Selecione a Empresa Responsável:</Form.Label>
                  <Form.Select
                    className="border border-secondary"
                    required
                    name="search2"
                    onChange={e => handleSearch2(e)}
                    value={search2}
                    disabled={!searchBy2}
                  >
                    <option value="">Selecione a Empresa Responsável</option>
                    {tiEmpresasResp.map(item => (
                      <option key={item} value={item}>{item}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {searchBy2 === 'data' && (
              <Col sm={4}>
                <Form.Group controlId="search2" className={styles.searchField}>
                  <Form.Label>Selecione uma data:</Form.Label>
                  <Form.Control
                    type="date"
                    name="search2"
                    onChange={e => handleSearch2(e)}
                    value={search2}
                    disabled={!searchBy2}
                  />
                </Form.Group>
              </Col>
            )}
          </Row>
        )}
      </Form>
      )}

      {!loading && chamados?.length <= 0 && (
        <p>Você ainda não tem nenhuma solicitação cadastrada.</p>
      )}

      {!loading && chamados?.length > 0 && (
        <>
          <Table striped bordered hover responsive className={styles.chamadosTable}>
            <thead>
              <tr>
                <th style={{ width: '10%' }}>
                  <div className={styles.table_head}>
                    <span>Código</span>
                  </div>
                </th>

                <th style={{ width: '23%' }}>
                  <div className={styles.table_head}>
                    <span>Categoria</span>
                  </div>
                </th>
                <th>
                  <div className={styles.table_head}>
                    <span>Subcategoria</span>
                  </div>
                </th>
                <th style={{ width: '23%' }}>
                  <div className={styles.table_head}>
                    <span>Nome</span>
                  </div>
                </th>
                <th style={{ width: '23%' }}>
                  <div className={styles.table_head}>
                    <span>Lotação</span>
                  </div>
                </th>
                <th style={{ width: '13%' }}>
                  <div className={styles.table_head}>
                    <span>Status</span>
                  </div>
                </th>
                <th style={{ width: '13%' }}>
                  <div className={styles.table_head}>
                    <span>Data Início</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {chamados && chamados.map(chamado => {
                return (
                  <tr
                    key={chamado._id}
                    style={{
                      backgroundColor:
                        chamado.status === 'Aberto' ? '#ffcdd2' :
                          chamado.status === 'Em Andamento' ? '#fff9c4' :
                            chamado.status === 'Finalizado' ? '#c8e6c9' :
                              chamado.status === 'Cancelado' ? '#e0e0e0' : ''
                    }}
                  >
                    <td className={styles.table_data}><Link to={`/solicitacao/${chamado.numeroChamado}`}>{includeLeftZero(chamado.numeroChamado)}</Link></td>
                    <td className={styles.table_data}>{chamado.categoria}</td>
                    <td className={styles.table_data}>{chamado.subcategoria}</td>
                    <td className={styles.table_data}>{decrypt(chamado.nome)}</td>
                    <td className={styles.table_data}>{chamado.unidade}</td>
                    <td className={styles.table_data}>{chamado.status}</td>
                    <td className={styles.table_data}>{formatDateTime(chamado.createdAt)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <PaginationMenu
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />

          <Modal show={showModal} onHide={handleModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Sucesso</Modal.Title>
            </Modal.Header>
            <Modal.Body>Solicitação gravada com sucesso!</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleModalClose}>
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showModalBusca} onHide={handleModalBuscaClose}>
            <Modal.Header closeButton>
              <Modal.Title>Erro!</Modal.Title>
            </Modal.Header>
            <Modal.Body>Não existe o código digitado na sua lista de solicitações</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleModalBuscaClose}>
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </Container>
  );
};

export default Chamados;
